import React from 'react';
import ForgotPassword from '../ForgotPassword/ForgotPassword';

const ActivateAccount = () => {
  return <ForgotPassword isFromActivateAccount />;
};

export default ActivateAccount;
